import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { DEFAULT_VCARD_FORM_VALUES } from '@/constants/VCard'
import { VCardFormSchema } from '@/lib/schemas/authUser/vCard'

export interface UIState {
  companySwitching: boolean
  showModalSubscriptionList: boolean
  sidebarCollapsed: boolean
  onboardingCardPreview: VCardFormSchema
}

const initialState: UIState = {
  companySwitching: false,
  showModalSubscriptionList: false,
  sidebarCollapsed: false,
  onboardingCardPreview: DEFAULT_VCARD_FORM_VALUES,
}

const uiSlice = createSlice({
  name: 'company',
  initialState,
  reducers: {
    setCompanySwitching(state, action: PayloadAction<boolean>) {
      state.companySwitching = action.payload
    },
    setShowModalSubscriptionList(state, action: PayloadAction<boolean>) {
      state.showModalSubscriptionList = action.payload
    },
    setSidebarCollapsed(state, action: PayloadAction<boolean>) {
      state.sidebarCollapsed = action.payload
    },

    updateOnboardingCardPreview(state, action: PayloadAction<Partial<VCardFormSchema>>) {
      state.onboardingCardPreview = {
        ...state.onboardingCardPreview,
        ...action.payload,
      }
    },

    resetOnboardingCardPreview(state) {
      state.onboardingCardPreview = DEFAULT_VCARD_FORM_VALUES
    },
  },
})

export const {
  setCompanySwitching,
  setSidebarCollapsed,
  resetOnboardingCardPreview,
  updateOnboardingCardPreview,
  setShowModalSubscriptionList,
} = uiSlice.actions
export default uiSlice.reducer
